import React from 'react';

export default class HeaderSecond extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        data : null
      };
    }


	render() {
		return (
			<div class="chosen-category-form">
				{this.props.showTotal &&			
					<div class="chosen-category-form_title">
						Пожалуйста, выберите магазины/бренды, которые Вы бы хотели видеть в нашем ТРЦ
					</div>	
				}
				{this.props.category &&
					<div>

						<header class="chosen-category-form_heading">
							<h1>{this.props.category}</h1>
							<a href="" class="text-chosen" onClick={e => this.props.changeStep('selected',e)}>Выбрано:&nbsp;&nbsp;&nbsp;{this.props.countInCategory}</a>
						</header>
					</div>
				}
				{this.props.showTotal &&
					<div class="chosen-category-form_other">
						<span class="chosen-category-form_other_text"><a href="" onClick={e => this.props.changeStep('selected',e)}>Выбрано</a> по всем категориям: {this.props.selectedTotal}</span>
						<button class="btn blank" onClick={this.props.resetSearch}>Выбрать в другой категории</button>
					</div>
				}
			</div>
		);
	}

}